<template>
  <div class="creative-label">
    <el-form-item
      prop="creativeClass"
      style="margin-bottom: 0"
      :rules="[
        {
          required: true,
          message: '请选择某个分类',
          trigger: 'blur',
        },
      ]"
    >
      <div class="creative-class">
        <p class="level-2">
          创意分类
          <el-popover placement="top" trigger="hover">
            <p style="font-size: 12px">
              根据创意内容选择合适的创意分类可以帮助找到更合适的流量
            </p>
            <i class="el-icon-question" slot="reference"></i>
          </el-popover>
        </p>
        <el-cascader
          class="t-input"
          v-model="form.creativeClass"
          :options="options"
          :props="{ value: 'label' }"
        ></el-cascader>
      </div>
    </el-form-item>
    <div v-if="isStandard">
      <p class="level-2">
        创意标签
        <el-popover placement="top" trigger="hover">
          <p style="font-size: 12px">
            手动给创意打上合适的标签可以帮助找到更合适的流量
          </p>
          <i class="el-icon-question" slot="reference"></i>
        </el-popover>
      </p>

      <div class="input-area">
        <el-input
          class="t-input t-s-input"
          type="text"
          size="small"
          placeholder="输入标签,可用空格分割"
          v-model="labelStr"
          @keyup.enter.native="handleAdd"
        >
        </el-input>
        <div class="add-btn" @click="handleAdd">添加(回车)</div>
      </div>

      <div class="tags-area">
        <div class="tags-area-header">
          <p class="tags-count">
            已选 <span>{{ form.creativeLabels.length }}</span
            >/20
          </p>
          <span
            class="clear-btn"
            :class="{ disabled: form.creativeLabels.length == 0 }"
            @click="form.creativeLabels = []"
            >清空</span
          >
        </div>
        <div class="tags-area-body">
          <div
            class="tag"
            v-for="(item, idx) in form.creativeLabels"
            :key="idx"
          >
            {{ item }}
            <i class="el-icon-close" @click="handleDel(idx)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import category from "@/utils/category.js";

export default {
  props: {
    form: Object,
    isStandard: Boolean,
  },
  data() {
    return {
      options: category.options,
      labelStr: "",
    };
  },
  methods: {
    handleAdd() {
      let str = this.labelStr.trim();
      let tagArr = str.split(/\s+/);
      if (str == "") {
        this.labelStr = "";
        return;
      } else if (
        tagArr.some((tag) => {
          return tag.length > 10;
        })
      ) {
        this.$message.warning("一个标签1 ~ 10个字，请正确输入");
        return;
      } else if (tagArr.length + this.form.creativeLabels.length > 20) {
        this.$message.warning("最多添加20个标签");
        return;
      } else this.form.creativeLabels = this.form.creativeLabels.concat(tagArr);

      this.labelStr = "";
    },
    handleDel(idx) {
      this.form.creativeLabels.splice(idx, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.creative-label {
  .level-2 {
    margin-top: 28px;
    margin-bottom: 12px;
    line-height: 20px;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }
  .el-icon-question {
    margin-left: 3px;
    color: #d3d3d3;
    font-size: 16px;
    vertical-align: -1px;
    cursor: pointer;
  }
  ::v-deep .t-input {
    &.t-input {
      width: 400px;
    }
    &.t-s-input {
      width: 292px;
    }
    .el-input__inner {
      background-color: #f2f2f2;
    }
  }
  .add-btn {
    display: inline-block;
    margin-left: 8px;
    padding: 5px 16px;
    user-select: none;
    min-width: 100px;
    font-size: 14px;
    line-height: 22px;
    border-radius: 4px;
    color: #333;
    background-color: #fff;
    border: solid 1px #999;
    cursor: pointer;
    &:hover {
      background-color: #edf1fd;
      border-color: #194ce5;
    }
  }

  .tags-area {
    margin-top: 20px;
    width: 400px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    .tags-area-header {
      padding: 0 12px;
      height: 38px;
      line-height: 38px;
      background-color: #f2f2f2;
      font-weight: 500;
      color: #333;
      font-size: 14px;
      .tags-count {
        float: left;
        span {
          color: #194ce5;
        }
      }
      .clear-btn {
        float: right;
        color: #194ce5;
        cursor: pointer;
        &.disabled {
          color: #333;
          opacity: 0.26;
          cursor: not-allowed;
        }
      }
    }
    .tags-area-body {
      height: 162px;
      overflow-y: auto;
      .tag {
        position: relative;
        display: inline-block;
        margin: 12px auto 0 12px;
        padding: 2px 6px;
        width: 45%;
        height: 26px;
        overflow: hidden;
        background-color: #f2f2f2;
        border-radius: 4px;
        color: #333;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        cursor: pointer;
        .el-icon-close {
          position: absolute;
          top: 7px;
          right: 7px;
          font-weight: bold;
          font-size: 12px;
        }
      }
    }
  }
}
</style>